<template>
  <transition name="privacy">
    <div v-if="show" class="privacy-modal">
      <swiper class="content" :options="swiperOption">
        <swiper-slide class="text ">
          <h3 class="text-center">隐私政策</h3>
          <br />
          <p class="text-indent-25">
            景德镇御窑厂管理处（以下简称“我们”）深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本“隐私政策”并特别提示：希望您在使用景德镇御窑厂官网及微信小程序服务前仔细阅读并理解本隐私政策，以便做出适当的选择。
          </p>
          <br />
          <ul>
            <li>
              <h4>1. 个人信息的收集和使用</h4>
              <br />
              <ul>
                <li>
                  <h5>1.1. 注册、登录</h5>
                  <br />
                  <p class="text-indent-25">
                    您可以使用第三方账号登录并使用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息）用于与景德镇御窑厂账号绑定，使您可以直接登录并使用本产品和相关服务。
                  </p>
                  <br />
                  <p class="text-indent-25">
                    如果第三方平台注册时，没有获取到您的手机号，您需要绑定手机号以便获取我们更及时充分的服务。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>1.2. 资讯浏览</h5>
                  <br />
                  <p class="text-indent-25">
                    景德镇御窑厂可能会向您推荐更感兴趣的信息，为实现这一功能，我们可能会收集必要的日志信息。用于信息展示的日志信息包括您操作、使用的行为信息：点击、收藏、搜索、浏览、分享。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>1.3. 搜索</h5>
                  <br />
                  <p class="text-indent-25">
                    您使用景德镇御窑厂的搜索服务时，我们会收集您的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>1.4. 安全运行</h5>
                  <br />
                  <p class="text-indent-25">
                    我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务是我们的核心目标。为实现安全保障功能所收集的信息是必要信息。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>1.5. 收集、使用个人信息目的的变更</h5>
                  <br />
                  <p class="text-indent-25">
                    请您了解，随着业务的发展，我们可能会对景德镇御窑厂软件的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>1.6. 依法豁免征得同意收集和使用的个人信息</h5>
                  <br />
                  <p class="text-indent-25">
                    请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：
                  </p>
                  <br />
                  <ul class="pl-25">
                    <li><br />(一) 与国家安全、国防安全直接相关的；<br /></li>
                    <li>
                      <br />(二)
                      与公共安全、公共卫生、重大公共利益直接相关的；<br />
                    </li>
                    <li>
                      <br />(三)
                      与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />
                    </li>
                    <li>
                      <br />(四)
                      出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                    </li>
                    <li>
                      <br />(五) 所收集的您的个人信息是您自行向社会公众公开的；
                      <br />
                    </li>
                    <li>
                      <br />(六)
                      从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br />
                    </li>
                    <li>
                      <br />(七) 根据您的要求签订或履行合同所必需的；<br />
                    </li>
                    <li>
                      <br />(八)
                      用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；<br />
                    </li>
                    <li><br />(九) 为合法的新闻报道所必需的；<br /></li>
                    <li>
                      <br />(十)
                      学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br />
                    </li>
                    <li><br />(十一) 法律法规规定的其他情形。 <br /></li>
                  </ul>
                  <br />
                  <p class="text-indent-25 underline">
                    特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。
                  </p>
                  <br />
                </li>
              </ul>
            </li>
            <li>
              <h4>2. 对Cookie和同类技术的使用</h4>
              <br />
              <p class="text-indent-25">
                Cookie和同类技术是互联网中普遍使用的技术。当您使用景德镇御窑厂软件及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个cookie或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们承诺，不会将
                cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用 cookie
                和同类技术主要为了实现以下功能或服务：
              </p>
              <br />
              <ul>
                <li>
                  <h5>2.1. 保障产品与服务的安全、高效运转</h5>
                  <br />
                  <p class="text-indent-25">
                    我们可能会设置认证与保障安全性的cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>2.2. 帮助您获得更轻松的访问体验</h5>
                  <br />
                  <p class="text-indent-25">
                    使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>2.3. Cookie的清除</h5>
                  <br />
                  <p class="text-indent-25">
                    大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。
                  </p>
                  <br />
                </li>
              </ul>
            </li>
            <li>
              <h4>3. 个人信息的共享、转让、披露</h4>
              <br />
              <ul>
                <li>
                  <h5>3.1. 共享</h5>
                  <br />
                  <ul>
                    <li>
                      <h6>3.1.1. 共享原则</h6>
                      <br />
                      <ul class="pl-25">
                        <li>
                          <strong>(一)授权同意原则：</strong>
                          向我们的关联方、第三方共享您的个人信息，需经过您的授权同意，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果关联方、第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。
                        </li>
                        <br />
                        <li>
                          <strong>(二)合法正当与最小必要原则：</strong>
                          向关联方、第三方共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。
                        </li>
                        <br />
                        <li>
                          <strong>(三)安全审慎原则：</strong>
                          我们将审慎评估关联方、第三方数据使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
                        </li>
                        <br />
                      </ul>
                    </li>
                    <li>
                      <h6>3.1.2. 实现安全与分析统计的共享信息</h6>
                      <br />
                      <ul class="pl-25">
                        <li>
                          <strong>(一)保障使用安全：</strong>
                          我们非常重视账号与服务安全，为保障您和其他用户的账号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联公司或服务提供商可能会共享必要的设备、账号及日志信息。
                        </li>
                        <br />
                        <li>
                          <strong>(二) 分析产品使用情况：</strong>
                          为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。
                        </li>

                        <br />
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5>3.2. 转让</h5>
                  <br />
                  <p class="text-indent-25">
                    我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。
                  </p>
                  <br />
                </li>
                <li>
                  <h5>3.3. 披露</h5>
                  <br />
                  <ul class="pl-25">
                    <li>
                      (一)
                      我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施。
                      <br />
                    </li>
                    <li>
                      <br />
                      (二) 对违规账号进行处罚公告时，我们会披露相关账号的信息。
                      <br />
                    </li>
                  </ul>
                  <br />
                </li>
                <li>
                  <h5>3.4. 依法豁免征得同意共享、转让、公开披露的个人信息</h5>
                  <br />
                  <p class="text-indent-25">
                    请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：
                  </p>
                  <br />
                  <ul class="pl-25">
                    <li><br />(一) 与国家安全、国防安全直接相关的； <br /></li>
                    <li>
                      <br />
                      (二) 与公共安全、公共卫生、重大公共利益直接相关的； <br />
                    </li>
                    <li>
                      <br />
                      (三) 与犯罪侦查、起诉、审判和判决执行等直接相关的； <br />
                    </li>
                    <li>
                      <br />
                      (四)
                      出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                      <br />
                    </li>
                    <li><br />(五) 您自行向社会公众公开的个人信息； <br /></li>
                    <li>
                      <br />
                      (六)
                      从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                      <br />
                    </li>
                  </ul>
                  <br />
                </li>
              </ul>
            </li>
            <li>
              <h4>4. 个人信息的存储</h4>
              <br />
              <ul>
                <li>
                  <h5 class="text-indent-25">4.1. 存储地点</h5>
                  <br />
                  <p class="text-indent-25">
                    我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。
                  </p>
                  <br />
                </li>
                <li>
                  <h5 class="text-indent-25">4.2. 存储期限</h5>
                  <br />
                  <p class="text-indent-25">
                    我们仅在为提供景德镇御窑厂软件及服务之目的所必需的期间内保留您的个人信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
                  </p>
                  <br />
                </li>
              </ul>
            </li>
            <li>
              <h4>5. 如何保护个人信息的安全</h4>
              <ul class="pl-25">
                <li class="text-indent-25">
                  <br />
                  (一)
                  我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  (二)
                  我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  <strong>
                    (三)
                    尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。
                  </strong>
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  (四)
                  您一旦离开景德镇御窑厂软件及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在景德镇御窑厂软件及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于景德镇御窑厂软件的链接或引导。
                  <br />
                </li>
              </ul>
              <br />
            </li>
            <li>
              <h4>6. 管理您的个人信息</h4>
              <br />
              <ul>
                <li>
                  <h5 class="text-indent-25">6.1. 访问个人账号信息</h5>
                  <br />
                  <p class="text-indent-25">
                    您可以在景德镇御窑厂软件的“个人中心”中访问您的头像、昵称、手机号码等个人信息。
                  </p>
                  <br />
                </li>
                <li>
                  <h5 class="text-indent-25">6.2. 访问隐私政策</h5>
                  <br />
                  <p class="text-indent-25">
                    您可以在注册页面查看本隐私政策全部内容。
                  </p>
                  <br />
                </li>
                <li>
                  <h5 class="text-indent-25">6.3. 停止运营向您告知</h5>
                  <br />
                  <p class="text-indent-25">
                    如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。
                  </p>
                  <br />
                </li>
              </ul>
              <br />
            </li>
            <li>
              <h4>7. 未成年人保护</h4>
              <ul class="pl-25">
                <li class="text-indent-25">
                  <br />
                  (一)
                  若您是未满18周岁的未成年人，在使用景德镇御窑厂软件及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  (二)
                  我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  (三)
                  若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。
                  <br />
                </li>
              </ul>
              <br />
            </li>
            <li>
              <h4>8. 隐私政策的修订和通知</h4>
              <ul class="pl-25">
                <li class="text-indent-25">
                  <br />
                  (一)
                  为了给您提供更好的服务，景德镇御窑厂软件及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。
                  <br />
                </li>
                <li class="text-indent-25">
                  <br />
                  (二)
                  本隐私政策更新后，我们会在景德镇御窑厂软件中发出更新版本，并在更新后的条款生效前通过官方网站（www.jdzyuyao.com）公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。
                  <br />
                </li>
              </ul>
              <br />
            </li>
            <li>
              <h4>9. 联系方式</h4>
              <br />
              <p class="text-indent-25">
                如果对本隐私政策内容有任何疑问、意见或建议，您可通过官方网站（www.jdzyuyao.com）首页下方公示的联系方式与我们进行沟通。
              </p>
              <br />
            </li>
          </ul>
        </swiper-slide>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>
      <div class="modal-close" @click="$emit('update:show', false)"></div>
    </div>
  </transition>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'privacy',
  props: {
    show: null
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.privacy-enter-active,
.privacy-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.privacy-enter,
.privacy-leave-to {
  opacity: 0;
}
</style>
